import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
import { useClinica } from '../../hooks/clinica';
import { TIPO_USUARIO } from '../../utils/funcoes';

import { Content, SidebarHeader, MenuHeader, MenuLink } from './styles';

const Avatar: React.FC = () => {
  const { user, clinica } = useAuth();
  const { optionsClinica, imagensClinica } = useClinica();

  const cliSaoPaulo = !!imagensClinica.find(img => img.nome === 'saopaulo');
  return (
    <Content className="border-right d-print-none">
      <SidebarHeader>Administrativo</SidebarHeader>

      <MenuHeader> Geral</MenuHeader>
      {user.UsuTipo <= TIPO_USUARIO.SUPERVISOR && (
        <>
          <MenuLink>
            <Link to="/usuario">Usuários</Link>
          </MenuLink>

          <MenuLink>
            <Link to="/medico">Médicos</Link>
          </MenuLink>

          <MenuLink>
            <Link to="/perfil">Perfil</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/agendaCadastro">Agendas</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/dianaoagendar">Dia Não Agendar</Link>
          </MenuLink>
          {clinica.acessaCupom && (
            <MenuLink>
              <Link to="/cupom">Cupom</Link>
            </MenuLink>
          )}
          {user.UsuTipo === TIPO_USUARIO.ADMINISTRADOR && (
            <MenuLink>
              <Link to="/procedimento">Procedimentos</Link>
            </MenuLink>
          )}
          <MenuLink>
            <Link to="/usuariosaniversariantes">
              Colaboradores Aniversariantes
            </Link>
          </MenuLink>
          <MenuLink>
            <Link to="/cadastrocontrato">Contratos</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/palavrasbloqueadas">Palavras Bloqueadas</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/grupoexames">Grupo de Exames</Link>
          </MenuLink>
        </>
      )}

      {user.UsuTipo <= TIPO_USUARIO.SUPERVISOR && (
        <>
          <MenuHeader> Prontuário</MenuHeader>
          <MenuLink>
            <Link to="/modelodocumento">Atestados, Receitas e Prontuários</Link>
          </MenuLink>
        </>
      )}
      {user.UsuTipo === TIPO_USUARIO.MEDICO && (
        <>
          <MenuHeader> Receitas</MenuHeader>
          <MenuLink>
            <Link to="/receitas">Gerenciar Receitas</Link>
          </MenuLink>
        </>
      )}
      <MenuHeader> Relacionamento Paciente</MenuHeader>
      <MenuLink>
        <Link to="/atendimentoparticular">Atendimentos Particulares</Link>
      </MenuLink>
      <MenuLink>
        <Link to="/aniversariantes">Pacientes Aniversariantes</Link>
      </MenuLink>
      <MenuLink>
        <Link to="/agendaenvioconfirmacao">Confirmação Agendamento</Link>
      </MenuLink>
      {user.UsuTipo <= TIPO_USUARIO.SUPERVISOR && (
        <MenuLink>
          <Link to="/modelomensagem">Modelos de Mensagem</Link>
        </MenuLink>
      )}
      {user.UsuTipo < TIPO_USUARIO.ATENDENTE_CAIXA && (
        <>
          <MenuHeader> Relacionamento Médico</MenuHeader>
          <MenuLink>
            <Link to="/consultarpagamentosMedicos">Consultar Pagamentos</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/pagamentosMedicos">Gerar Pagamentos</Link>
          </MenuLink>
          {/* <MenuLink>
            <Link to="/pagamentosMedicos">Modelo de Recibo</Link>
          </MenuLink> */}
        </>
      )}

      <MenuHeader> Financeiro</MenuHeader>
      {user.UsuTipo <= TIPO_USUARIO.SUPERVISOR && (
        <>
          <MenuLink>
            <Link to="/despesas">Despesas</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/despesasresumo">Demonstrativo de Despesas</Link>
          </MenuLink>
          {clinica.CliDrSaude && (
            <MenuLink>
              <Link to="/outrasreceitas">Outras Receitas</Link>
            </MenuLink>
          )}
        </>
      )}
      {clinica.CliEmiteNotaFiscal === true && (
        <>
          <MenuLink>
            <Link to="/servicosnotafiscal">Serviços Nota Fiscal</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/notasfiscais">Nota Fiscal</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/relatorionotasfiscais">Relatório Notas Fiscais</Link>
          </MenuLink>
        </>
      )}
      <MenuHeader> Relatórios</MenuHeader>
      {user.UsuTipo <= TIPO_USUARIO.SUPERVISOR && (
        <>
          <MenuLink>
            <Link to="/produtividade">Produtividade</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/produtividadeExames">
              Produtividade - Exames Antecipado
            </Link>
          </MenuLink>
          <MenuLink>
            <Link to="/produtividadeExamesTotal">
              Produtividade - Exames Total
            </Link>
          </MenuLink>
          <MenuLink>
            <Link to="/fechamentocaixa">Fechamento Caixa</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/fechamentodia">Fechamento do Dia</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/fechamentoconferencia">Fechamento Conferencia</Link>
          </MenuLink>
        </>
      )}
      <MenuLink>
        <Link to="/procedimentosrealizados">Procedimentos Realizados</Link>
      </MenuLink>
      {user.UsuTipo <= TIPO_USUARIO.SUPERVISOR && (
        <>
          <MenuLink>
            <Link to="/procedimentosrealizadosvalor">
              Procedimentos Realizados Valor
            </Link>
          </MenuLink>
          <MenuLink>
            <Link to="/quantidadeprocedimentos">
              Quantidade de Procedimentos Realizados
            </Link>
          </MenuLink>
          {clinica.CliAtendeConvenio && (
            <MenuLink>
              <Link to="/procedimentosrealizadosconvenio">
                Procedimentos Realizados Convênio
              </Link>
            </MenuLink>
          )}
          {cliSaoPaulo && (
            <>
              <MenuLink>
                <Link to="/fechamentoterceiro">
                  Fechamento de exames realizados em terceiro (Raio-x e
                  Tomografia) - Teste
                </Link>
              </MenuLink>
              <MenuLink>
                <Link to="/fechamentoParceiroVoucher">
                  Fechamento Parceiro Voucher
                </Link>
              </MenuLink>
            </>
          )}
          <MenuLink>
            <Link to="/dashboardagendamento">Dashboard Agendamento</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/resumogerencial">Resumo Gerencial</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/resumocartaosaude">Resumo Cartão Saúde</Link>
          </MenuLink>
        </>
      )}
      <MenuLink>
        <Link to="/cartaosaudelistagem">Cartão Saúde Listagem</Link>
      </MenuLink>
      {user.UsuTipo <= TIPO_USUARIO.SUPERVISOR && optionsClinica.length > 1 && (
        <>
          <MenuLink>
            <Link to="/pagaroutraunidade">À Pagar Outra Unidade</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/receberoutraunidade">À Receber Outra Unidade</Link>
          </MenuLink>
        </>
      )}
      {user.UsuTipo <= TIPO_USUARIO.ADMINISTRADOR && (
        <>
          <MenuHeader>Agendamentos</MenuHeader>
          <MenuLink>
            <Link to="/primeiroagendamentoonline">
              Pacientes 1º Agendamento Online
            </Link>
          </MenuLink>
          {cliSaoPaulo && (
            <>
              <MenuLink>
                <Link to="/primeiroagendamentowhatsapp">
                  Pacientes 1º Agendamento WhatsApp
                </Link>
              </MenuLink>
              <MenuLink>
                <Link to="/agendamentosWhatsapp">Agendamentos WhatsApp</Link>
              </MenuLink>
            </>
          )}
          <MenuLink>
            <Link to="/primeiroatendimento">Pacientes 1º Atendimento</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/dashboardagendamento">Dashboard Agendamento</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/medicosagendamentos">Agendamentos por Médico</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/dashboardmedico">Dashboard Médico</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/pedidoexamesgerencial">
              Pedido Exames Gerencial Valores
            </Link>
          </MenuLink>
          <MenuHeader>Enganjamento Whatsapp</MenuHeader>
          <MenuLink>
            <Link to="/enganjamentoTotalWhatsapp">Gastos Totais</Link>
          </MenuLink>
        </>
      )}
      {user.UsuTipo <= TIPO_USUARIO.SUPERVISOR && (
        <>
          <MenuHeader> Laboratório Álvaro</MenuHeader>

          <MenuLink>
            <Link to="/examessolicitados">Exames Solicitados</Link>
          </MenuLink>

          <MenuLink>
            <Link to="/conferenciaexamesalvaro">
              Conferência Exames Cobrados
            </Link>
          </MenuLink>

          <MenuLink>
            <Link to="/lucroexamesalvaro">Lucro Laboratório</Link>
          </MenuLink>
        </>
      )}

      <MenuHeader> Benefícios</MenuHeader>
      <MenuLink>
        <Link to="/vendasbeneficios">Relatório de Vendas</Link>
      </MenuLink>

      <MenuHeader> Cobrança</MenuHeader>
      <MenuLink>
        <Link to="/atrasados">Cobrança</Link>
      </MenuLink>
      <MenuLink>
        <Link to="/acordos">Acordos Realizados</Link>
      </MenuLink>
      {user.UsuTipo <= TIPO_USUARIO.SUPERVISOR && (
        <>
          <MenuLink>
            <Link to="/cobrancasrealizadas">Cobranças Realizadas</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/resumocobrancas">Resumo de Cobranças</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/recebimentos31">Recebimentos mais de 31 dias</Link>
          </MenuLink>
          <MenuLink>
            <Link to="/recebimentosmes">Recebimentos dentro do mês</Link>
          </MenuLink>
        </>
      )}
      {clinica.IntegracaoWhatsapp && user.UsuTipo <= TIPO_USUARIO.SUPERVISOR && (
        <>
          <MenuHeader> Integrações</MenuHeader>

          <MenuLink>
            <Link to="/whatsapp">Whatsapp</Link>
          </MenuLink>
        </>
      )}
    </Content>
  );
};

export default Avatar;
